import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { HeadquartersModel } from '../../../models/configuration/company/headquarters.model';

export class GetHeadquartersByCompanyidUseCase
  implements UseCase<{ idServicio: string }, HeadquartersModel>
{
  constructor(private configurationRepository: ConfigurationRepository) {}

  execute(params: { idServicio: string }): Observable<HeadquartersModel> {
    return this.configurationRepository.getHeadquartersByCompanyid(params);
  }
}